module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-smoothscroll/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"ReactConfBR2021","short_name":"starter","start_url":"/","background_color":"#111111","theme_color":"#d53a9d","display":"minimal-ui","icon":"src/assets/images/logoicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"8fb2a9d54d84af60e5fce04977c26102"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
